var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Position/Fret/Content/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { isNil } from 'ramda';
import { Note } from 'tonal';
import Wrapper from './Wrapper';
import NoteContent from './NoteContent';

const Content = ({
  content,
  noteType,
  showEnharmonics
}) => {
  const isNote = !isNil(Note.name(content));
  return /*#__PURE__*/React.createElement(Wrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, isNote ? /*#__PURE__*/React.createElement(NoteContent, _extends({
    note: content
  }, {
    noteType,
    showEnharmonics
  }, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 11
    }
  })) : content);
};

Content.propTypes = {
  content: pt.string.isRequired,
  noteType: pt.string.isRequired,
  showEnharmonics: pt.bool.isRequired
};
export default Content;
